import React, { useState, useEffect } from "react";
import SideNavigation from "../../components/dumb/contractor/SideNavigation";
import { useSelector } from "react-redux";
import useAuthEffect from "../../hook/useAuthEffect";
import useStatusThunk from "../../hook/useStatusThunk";
import { Table } from "../../components/dumb/DataTable";
import FinishTask from "../../components/smart/buttonPopups/FinishTask";
import { fetchContractorTasks } from "../../redux/ducks/task";
import { extractIDsDataAsArray } from "../../helpers/mapRow";

const TasksRoute = () => {
    const [rows, setRows] = useState([]);
    const tasks = useSelector(state => state.task.tasks);
    const [dispatchFetchTasks, status, error] = useStatusThunk(fetchContractorTasks);
    const userID = useSelector(state => state.session.userID);
    const userTasks = useSelector(state => state.user.users[userID]?.assignedTasks);

    //Initial title data
    useAuthEffect(() => dispatchFetchTasks());

    const [checkValues, setCheckValues] = useState([]);

    //Row data
    useEffect(() => {
        if (status == "success") {

            const translations = extractIDsDataAsArray(userTasks.t, tasks).map(item => ({ ...item, type: "t", displayType: "translation", due: item.t_due, completed: item.tCompleted }));
            const edits = extractIDsDataAsArray(userTasks.e, tasks).map(item => ({ ...item, type: "e", displayType: "edit", due: item.e_due, completed: item.eCompleted }));

            setRows(translations.concat(edits));
        }
    }, [status, tasks]);

    const titleContent = <FinishTask taskID={checkValues.length == 1 ? checkValues[0] : null} />

    //Render row of title table
    const renderRow = (row, renderData) => {

        return <React.Fragment>
            {renderData(row.ID, { key: "id" })}
            {renderData(row.name, { key: "name", here: "/task/translate/" + row.ID })}
            {renderData(row.displayType, { key: "type" })}
            {renderData(row.due, { key: "due" })}
            {renderData(row.completed, { key: "completed" })}
            {renderData(row.status, { key: "status" })}
            {renderData(row.status_due, { key: "statusDue" })}
            {renderData(row.source_lang, { key: "sourceLang" })}
            {renderData(row.target_lang, { key: "targetLang" })}
        </React.Fragment>
    }

    return (
        <div className="columns-container">
            <div className="column column--sidenav">
                <SideNavigation selected="tasks" />
            </div>

            <div className="column column--primary">
                <Table title="Assigned Tasks" titleContent={titleContent} checkbox={true} newCheckValues={setCheckValues} getCheckValue={row => row.ID} renderRow={renderRow} cols={[{ name: "task id", sortCol: "ID" }, { name: "name", sortCol: "name" }, { name: "type", sortCol: "displayType" }, { name: "your due", sortCol: "due" }, { name: "completed", sortCol: "completed" }, { name: "status", sortCol: "status" }, { name: "status due", sortCol: "status_due" }, { name: "source", sortCol: "src" }, { name: "target", sortCol: "trg" }]} rows={rows} />
            </div>
        </div>
    )
}

export default TasksRoute;